import { TFilterDataProps } from "../model/types/filterData";

export const filterLocations = [
  "North America",
  "United States",
  "San Francisco Bay Area",
  "New York",
  "Boston",
  "Austin",
  "Seattle",
  "Los Angeles",
  "Chicago",
  "Atlanta",
  "Denver",
  "San Diego",
  "Canada",
  "Central and South America",
  "Mexico",
  "Brazil",
  "Argentina",
  "Chile",
  "Colombia",
  "Peru",
  "Europe",
  "United Kingdom",
  "London",
  "Germany",
  "Berlin",
  "France",
  "Paris",
  "Spain",
  "Barcelona",
  "Benelux",
  "Belgium",
  "Netherlands",
  "Luxemburg",
  "Amsterdam",
  "Northern Europe",
  "Sweden",
  "Finland",
  "Denmark",
  "Norway",
  "Iceland",
  "Ireland",
  "Switzerland",
  "Portugal",
  "Estonia",
  "Latvia",
  "Poland",
  "Italy",
  "Austria",
  "Asia",
  "China",
  "Beijing",
  "Shanghai",
  "Shenzhen",
  "India",
  "Bangalore",
  "Mumbai",
  "Delhi",
  "Japan",
  "South Korea",
  "Singapore",
  "Israel",
  "Tel Aviv",
  "Hong Kong",
  "Pakistan",
  "SE Asia",
  "Indonesia",
  "Thailand",
  "Vietnam",
  "Middle East & Africa",
  "Turkey",
  "Saudi Arabia",
  "United Arab Emirates",
  "South Africa",
  "Kenya",
  "Nigeria",
  "Oceania",
  "Australia",
  "New Zealand"
];

export const defaultFilterData: TFilterDataProps = {
  stage: -1,
  tags: {},
  filteredFounders: [],
  filteredPartners: [],
  filteredInvestors: [],
  filteredLocations: filterLocations,
  location: "",
  latestFundingRound: {
    "Pre-Seed": false,
    Seed: false,
    "Series A": false,
    "Series B": false,
    "Series C": false,
    "Series D": false,
    "Series E+": false,
    Private: false,
    Undetermined: false,
    "Debt Financing": false,
    "IPO/Public Market": false,
    "Merge/Private Acquisition": false,
    "Out of Business": false,
    Grant: false
  },
  currentSelect: null,
  locationsTags: [],
  selectedLocation: "",
  selectedFounder: "",
  foundersTags: [],
  selectedInvestor: "",
  investorsTags: [],
  selectedPartner: "",
  partnersTags: [],
  fundingMin: "",
  fundingMax: "",
  name: ""
};

export const mockPartners = [
  { label: "Partners", value: "Partners" },
  { label: "Investors", value: "Investors" },
  { label: "Founders", value: "Founders" },
  { label: "Years", value: "Years" },
  { label: "Locations", value: "Locations" }
];

export const mockInvestors = [
  { label: "Venture Capital", value: "Venture Capital" },
  { label: "Private Equity", value: "Private Equity" },
  { label: "Angel", value: "Angel" },
  { label: "Seed", value: "Seed" },
  { label: "Series A", value: "Series A" },
  { label: "Series B", value: "Series B" }
];

export const mockFounders = [
  { label: "Solo founder", value: "Solo founder" },
  { label: "Co-founder", value: "Co-founder" },
  { label: "Multiple founders", value: "Multiple founders" },
  { label: "No founder", value: "No founder" },
  { label: "Founder not disclosed", value: "Founder not disclosed" },
  { label: "Founder not applicable", value: "Founder not applicable" },
  { label: "Founder not available", value: "Founder not available" }
];

export const mockYears = [
  { label: "2017", value: "2017" },
  { label: "2018", value: "2018" },
  { label: "2019", value: "2019" },
  { label: "2020", value: "2020" },
  { label: "2021", value: "2021" },
  { label: "2022", value: "2022" },
  { label: "2023", value: "2023" },
  { label: "2024", value: "2024" }
];

export interface ILocationsForFilterProps {
  filters: { [key: string]: string[] | undefined };
}

export const locationsForFilter: ILocationsForFilterProps = {
  filters: {
    "North America": ["United States", "Canada"],
    "United States": [],
    "San Francisco Bay Area": [
      "San Francisco Bay Area",
      "San Francisco",
      "Oakland",
      "San Jose",
      "Berkeley",
      "Palo Alto",
      "Santa Clara",
      "Sunnyvale",
      "Fremont",
      "Hayward",
      "San Mateo",
      "Redwood City",
      "Mountain View",
      "Concord",
      "Vallejo",
      "Antioch",
      "Richmond",
      "Daly City",
      "Vacaville",
      "South San Francisco",
      "San Rafael",
      "Novato",
      "San Leandro",
      "Livermore",
      "Napa",
      "Alameda",
      "Union City",
      "Pleasanton",
      "Walnut Creek",
      "Milpitas",
      "Pittsburg",
      "Cupertino",
      "San Ramon",
      "Petaluma",
      "Fairfield",
      "Menlo Park",
      "Dublin",
      "Newark",
      "San Bruno",
      "Santa Rosa",
      "Pacifica",
      "Martinez",
      "Pleasant Hill",
      "Los Gatos",
      "Burlingame",
      "San Carlos",
      "Sausalito",
      "Benicia",
      "Foster City",
      "Los Altos",
      "Half Moon Bay"
    ],
    Canada: [],
    "Central and South America": ["Mexico", "Brazil", "Argentina", "Chile", "Colombia", "Peru"],
    Mexico: [],
    Brazil: [],
    Argentina: [],
    Chile: [],
    Colombia: [],
    Peru: [],
    Europe: [
      "United Kingdom",
      "Germany",
      "France",
      "Spain",
      "Benelux",
      "Northern Europe",
      "Iceland",
      "Switzerland",
      "Portugal",
      "Estonia",
      "Latvia",
      "Poland",
      "Italy",
      "Austria"
    ],
    "United Kingdom": ["London"],
    London: [],
    Germany: ["Berlin"],
    Berlin: [],
    France: ["Paris"],
    Paris: [],
    Spain: ["Barcelona"],
    Barcelona: [],
    Benelux: ["Belgium", "Netherlands", "Luxembourg"],
    Belgium: [],
    Netherlands: [],
    Luxembourg: [],
    "Northern Europe": ["Sweden", "Finland", "Denmark", "Norway", "Ireland"],
    Sweden: [],
    Finland: [],
    Denmark: [],
    Norway: [],
    Ireland: [],
    Switzerland: [],
    Portugal: [],
    Estonia: [],
    Latvia: [],
    Poland: [],
    Italy: [],
    Austria: [],
    Asia: ["China", "India", "Japan", "South Korea", "Singapore", "Israel", "Hong Kong", "Pakistan", "SE Asia"],
    China: ["Beijing", "Shanghai", "Shenzhen"],
    Beijing: [],
    Shanghai: [],
    Shenzhen: [],
    India: ["Bangalore", "Mumbai", "Delhi"],
    Bangalore: [],
    Mumbai: [],
    Delhi: [],
    Japan: [],
    "South Korea": [],
    Singapore: [],
    Israel: ["Tel Aviv"],
    "Tel Aviv": [],
    "Hong Kong": [],
    Pakistan: [],
    "SE Asia": ["Indonesia", "Thailand", "Vietnam"],
    Indonesia: [],
    Thailand: [],
    Vietnam: [],
    "Middle East & Africa": ["Turkey", "Saudi Arabia", "United Arab Emirates", "South Africa", "Kenya", "Nigeria"],
    Turkey: [],
    "Saudi Arabia": [],
    "United Arab Emirates": [],
    "South Africa": [],
    Kenya: [],
    Nigeria: [],
    Oceania: ["Australia", "New Zealand"],
    Australia: [],
    "New Zealand": []
  }
};

export const initialCollapsedFilters: Record<string, boolean> = {
  tags: false,
  location: false,
  financialStage: false,
  funding: false
};
